__webpack_require__.p = "https://admin-panel-dev.winlocal.com/";